import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { dropdownLink } from 'app/models/dropdownLink.interface';
import { SessionService } from 'app/services/session.service';
import { LocalStorageService } from 'app/services/localStorage.service';
@Component({
  selector: 'menu-dropdown',
  templateUrl: './menu-dropdown.component.html',
  standalone: false,
})
export class MenuDropdownComponent implements OnInit {
  @Input() title: string;
  @Input() subtitle: string;
  @Input() dropdownTo: dropdownLink[] = [
    {
      path: 'legacy/dashboard',
      title: 'Dashboard',
      icon: 'layout-dashboard',
    },
    {
      path: 'dashboard/myprofile',
      title: 'Settings',
      icon: 'settings',
    },
    {
      path: 'dashboard/logout',
      title: 'Log out',
      icon: 'log-out',
    },
  ];
  @Output() closeMenuEvent = new EventEmitter<boolean>();

  constructor(private sessionService: SessionService, private localStorageService: LocalStorageService) {}

  ngOnInit() {
    let userInfo = null;
    const userStr = this.localStorageService.getItem('user');
    if (userStr) {
      try {
        userInfo = JSON.parse(userStr);
      } catch (e) {
        userInfo = null;
      }
    }
    if (userInfo && !userInfo['isDevhubUser']) {
      const logoutIndex = this.dropdownTo.findIndex((item) => item.path === 'dashboard/logout');
      if (logoutIndex !== -1) {
        this.dropdownTo[logoutIndex].path = 'account/logout'; // Update path for non-Devhub users
      }
    }
  }

  closeMenu() {
    this.closeMenuEvent.emit(true);
  }
}
